export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/v1',
  API_KEY: import.meta.env.VITE_API_KEY || '',
  TIMEOUT: 30000,
};

export const COGNITO_CONFIG = {
  USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  REGION: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
};

export const PAGINATION = {
  DEFAULT_LIMIT: 50,
  MAX_LIMIT: 1000,
};

export const AUDIO = {
  DEFAULT_VOLUME: 1.0,
  SEEK_STEP: 5, // seconds
};

export const ROUTES = {
  HOME: '/',
  SONG_DETAILS: '/songs/:songId',
  PLAYLISTS: '/playlists',
  LOGIN: '/login',
  SIGNUP: '/signup',
};
